module.exports = __webpack_public_path__ + "static/media/cityhall.c73c7236.jpg";